import { useMutation } from "@shared/lib/hooks";
import { BackednResponse } from "@shared/lib/types";
import { IGetPermissionGroups } from "@shared/lib/types/permissions";
import { PoliciesService } from "../services/policies.service";

export const useCreatePermissionGroup = (queryKey?: any) => {
  const {
    mutate: createPermissionGroup,
    isLoading: isPermissionGroupCreating,
    isSuccess: isPermissionGroupCreated,
    error: permissionGroupError,
  } = useMutation({
    mutationFn: (payload: {
      brandOrganisationId: string;
      name: string;
      permissions: string[];
      description?: string;
    }) => PoliciesService.createPermissionGroup(payload),

    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, data, params) => {
      if (queryKey) {
        c.setQueryData(
          queryKey,
          (oldData: BackednResponse<IGetPermissionGroups>) => ({
            ...oldData,
            data: {
              ...oldData?.data,
              data: [
                ...oldData?.data?.data,
                {
                  ...data.data,
                },
              ],
            },
          })
        );
      }
      // c.invalidateQueries({
      //   queryKey: [...PERMISSION_GROUPS_QUERY_KEY, params.brandOrganisationId],
      // });
    },
  });

  return {
    createPermissionGroup,
    isPermissionGroupCreating,
    isPermissionGroupCreated,
    permissionGroupError,
  };
};
